export const FLAG_SUPPLIER_ACTIVITY = 'FLAG_SUPPLIER_ACTIVITY';
export const GET_SUPPLIER = 'GET_SUPPLIER';
export const CLEAR_SUPPLIER = 'CLEAR_SUPPLIER';
export const FLAG_GETTING_SUPPLIERS = 'FLAG_GETTING_SUPPLIERS';
export const GET_SUPPLIERS = 'GET_SUPPLIERS';
export const CLEAR_SUPPLIERS = 'CLEAR_SUPPLIERS';
export const FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY =
  'FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY';
export const GET_SUPPLIER_FOOD_TYPE = 'GET_SUPPLIER_FOOD_TYPE';
export const CLEAR_SUPPLIER_FOOD_TYPE = 'CLEAR_SUPPLIER_FOOD_TYPE';
